export const CHECK_TOKEN = 'CHECK_TOKEN';

export const SAVE_WRONG_PASS = 'SAVE_WRONG_PASS';